import { createEmiColumnHelper } from "components/table";
import { modelTaskColumnDefinitions } from "helpers/modelTaskColumnContract";

const columnHelper = createEmiColumnHelper();

const createModelTaskColumns = ({
	t,
	showOperatingMode,
	showSystem,
	customCaptions,
	modelType,
}) => {
	const context = { t, customCaptions, modelType, showOperatingMode, showSystem };
	const definitions = modelTaskColumnDefinitions.filter(
		(definition) => definition.isVisible?.(context) ?? true
	);

	return {
		// The row body reads cells by these keys directly (rows[col]), separate
		// from the columnDefs below - so displayField can diverge from the
		// column's sort id without touching how sorting works.
		columns: definitions.map(({ id, displayField }) => displayField ?? id),
		columnDefs: columnHelper.columns(
			definitions.map((definition) =>
				columnHelper.accessor(definition.id, {
					header: definition.label(context),
					enableSorting: definition.sortable !== false,
					meta: { width: definition.width },
				})
			)
		),
	};
};

export default createModelTaskColumns;
